class WorksSingle {
  constructor(el, opt) {
    this.el = el;
    if ($('.' + this.el).length > 0) {
      this.galleryInit();
      this.pointsSwiperInit();
      this.relatedSwiperInit();
      this.youtubeInit();
    }
  }

  galleryInit() {
    const galleryEl = document.querySelector('.js-works-gallery-main');
    if (!galleryEl) return;

    const slides = galleryEl.querySelectorAll('.swiper-slide');
    const dots   = document.querySelectorAll('.js-gallery-dot');

    const updateDots = (index) => {
      dots.forEach((dot, i) => {
        dot.classList.toggle('bg-[#2A892C]', i === index);
        dot.classList.toggle('bg-[#BBBBBB]',  i !== index);
      });
    };

    const swiper = new Swiper(galleryEl, {
      slidesPerView: 1,
      speed: 500,
      loop: slides.length > 1,
      navigation: {
        nextEl: '.js-gallery-next',
        prevEl: '.js-gallery-prev',
      },
      on: {
        init(sw) {
          updateDots(sw.realIndex);
        },
        slideChange(sw) {
          updateDots(sw.realIndex);
        },
      },
    });

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => swiper.slideToLoop(i));
    });
  }

  pointsSwiperInit() {
    const swiperEl  = document.querySelector('.js-works-points-swiper');
    if (!swiperEl) return;

    const wrapper    = swiperEl.closest('.relative');
    const prevBtn    = wrapper?.querySelector('.js-points-prev');
    const nextBtn    = wrapper?.querySelector('.js-points-next');
    const dotsWrap   = wrapper?.querySelector('.js-points-dots-wrap');
    const dots       = wrapper ? wrapper.querySelectorAll('.js-points-dot') : [];
    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    const pcDisabled = slideCount <= 3;

    const updateDots = (index) => {
      dots.forEach((dot, i) => {
        dot.classList.toggle('bg-[#2A892C]', i === index);
        dot.classList.toggle('bg-[#BBBBBB]',  i !== index);
      });
    };

    const setNavVisible = (visible) => {
      [prevBtn, nextBtn, dotsWrap].forEach(el => {
        if (el) el.style.display = visible ? '' : 'none';
      });
    };

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1.35,
      spaceBetween: 15,
      speed: 500,
      centeredSlides: true,
      watchOverflow: true,
      loop: slideCount > 2,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
          enabled: !pcDisabled,
        },
      },
      on: {
        init(sw) {
          updateDots(sw.realIndex);
          setNavVisible(sw.enabled && !sw.isLocked);
        },
        slideChange(sw) {
          updateDots(sw.realIndex);
        },
        lock(sw) {
          setNavVisible(false);
        },
        unlock(sw) {
          setNavVisible(true);
          updateDots(sw.realIndex);
        },
        disable() {
          setNavVisible(false);
        },
        enable(sw) {
          setNavVisible(!sw.isLocked);
          updateDots(sw.realIndex);
        },
        breakpoint(sw) {
          setNavVisible(sw.enabled && !sw.isLocked);
          updateDots(sw.realIndex);
        },
      },
    });

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => swiper.slideTo(i));
    });
  }

  youtubeInit() {
    document.querySelectorAll('.js-youtube-wrap').forEach(wrap => {
      wrap.addEventListener('click', () => {
        const id = wrap.dataset.youtubeId;
        if (!id) return;
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1`;
        iframe.setAttribute('allow', 'autoplay; encrypted-media');
        iframe.setAttribute('allowfullscreen', '');
        iframe.className = 'absolute inset-0 w-full h-full';
        wrap.innerHTML = '';
        wrap.appendChild(iframe);
      });
    });
  }

  relatedSwiperInit() {
    const swiperEl    = document.querySelector('.js-related-works-swiper');
    if (!swiperEl) return;

    const container    = swiperEl.closest('.js-related-swiper-container');
    const navWrap      = container ? container.querySelector('.js-related-swiper-nav') : null;
    const progressFill = container ? container.querySelector('.js-related-swiper-progress-fill') : null;
    const prevBtn      = container ? container.querySelector('.js-related-swiper-prev') : null;
    const nextBtn      = container ? container.querySelector('.js-related-swiper-next') : null;

    const count     = parseInt(swiperEl.dataset.count, 10) || 0;
    const pcEnabled = count >= 3;

    const updateProgress = (sw) => {
      if (!progressFill) return;
      progressFill.style.width = `${sw.progress * 100}%`;
    };

    const updateNav = (sw) => {
      if (prevBtn) prevBtn.classList.toggle('opacity-30', sw.isBeginning);
      if (nextBtn) nextBtn.classList.toggle('opacity-30', sw.isEnd);
    };

    const setNavVisible = (visible) => {
      if (navWrap) navWrap.style.display = visible ? '' : 'none';
    };

    new Swiper(swiperEl, {
      slidesPerView: 1.4,
      speed: 500,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        768: {
          slidesPerView: 3.3,
          enabled: pcEnabled,
        },
      },
      on: {
        init(sw) {
          updateProgress(sw);
          updateNav(sw);
          setNavVisible(sw.enabled);
        },
        slideChangeTransitionStart(sw) {
          updateProgress(sw);
          updateNav(sw);
        },
        enable(sw) {
          setNavVisible(true);
          updateProgress(sw);
          updateNav(sw);
        },
        disable() {
          setNavVisible(false);
        },
        breakpoint(sw) {
          setNavVisible(sw.enabled);
        },
      },
    });
  }
}
